/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from 'react';
import styled from 'styled-components';
import { SelectField, SelectFieldProps } from '@oneaudi/unified-web-components';

import { useI18n } from '@oneaudi/i18n-context';
import mapContext from '../../../contexts/map-context';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';
import { trackRadiusChangeAction } from '../../../utils/trackingUtils';
import trackingContext from '../../../contexts/tracking-context';
import { messages } from '../../../i18n/messages';

const useHandleSetSearchRadius = () => {
  const { trackingService: tService } = trackingContext.useTrackingState();
  const dispatch = mapContext.useMapDispatch();

  return (item: React.ChangeEvent<HTMLSelectElement>) => {
    trackRadiusChangeAction(
      tService,
      `${item.target.value}km`,
      item.target.value,
      'SearchRadiusDropdown',
      window.location.href,
    );
    dispatch({ type: ActionTypes.setSearchRadius, payload: Number(item.target.value) });
  };
};

export const SearchRadiusDropdown = () => {
  const selectRef = React.useRef<HTMLSelectElement | null>(null);
  const { searchRadius, searchRadiusOptions, distanceUnit } = mapContext.useMapState();
  const onSetSearchRadius = useHandleSetSearchRadius();

  React.useEffect(() => {
    document
      .getElementById('search_radius_dropdown')
      ?.setAttribute('aria-label', 'Search radius dropdown');

    if (selectRef.current?.firstChild) {
      selectRef.current?.removeChild(selectRef.current?.firstChild);
    }
  }, []);

  return (
    <CustomSelect
      id="search_radius_dropdown"
      label={useI18n(messages.search_radius)}
      onChange={onSetSearchRadius}
      value={searchRadius.toString()}
      required
      spaceInlineStart="s"
      spaceStackEnd="m"
      // eslint-disable-next-line no-return-assign
      inputRef={(inputRef: HTMLSelectElement | null) => (selectRef.current = inputRef)}
    >
      {searchRadiusOptions.map((optionValue) => (
        <option key={optionValue} value={optionValue.toString()}>
          {`${optionValue} ${distanceUnit}`}
        </option>
      ))}
    </CustomSelect>
  );
};

export const CustomSelect = styled((props) => <SelectField {...props} />)<SelectFieldProps>`
  min-width: 0;
  width: 82%;
  #search_radius_dropdown {
    margin-top: 0;
  }

  select {
    width: unset;
  }
  label {
    width: 100% !important;
  }

  hr {
    top: calc(56px - 20px + 1px) !important;
  }

  svg {
    top: 7px;
  }

  > label {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    border: 0;
    padding: 0;
    clip: rect(0 0 0 0);
    overflow: hidden;
  }
`;
